import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PluginIcon = _resolveComponent("PluginIcon")!
  const _component_PluginDetails = _resolveComponent("PluginDetails")!

  return (_openBlock(), _createElementBlock("span", null, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.showIcon)
      ? (_openBlock(), _createBlock(_component_PluginIcon, {
          key: 0,
          detail: _ctx.detail
        }, null, 8, ["detail"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "titleprefix", {}, undefined, true),
    (_ctx.showTitle)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(_ctx.titleCss),
          style: {"margin-left":"5px"}
        }, _toDisplayString(_ctx.title), 3))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "descriptionprefix", {}, undefined, true),
    _renderSlot(_ctx.$slots, "description", {}, () => [
      _createVNode(_component_PluginDetails, {
        "show-description": _ctx.showDescription,
        "show-extended": _ctx.showExtended,
        description: _ctx.description,
        "description-css": _ctx.descriptionCss,
        "extended-css": _ctx.extendedCss
      }, null, 8, ["show-description", "show-extended", "description", "description-css", "extended-css"])
    ], true),
    _renderSlot(_ctx.$slots, "suffix", {}, undefined, true)
  ]))
}